import { AlertProps } from "antd";
import { AlertStyled } from "./index.styled";

interface CustomAlertProps extends AlertProps {
  inline?: boolean;
}

export const CustomAlert: React.FC<CustomAlertProps> = ({
  inline,
  ...props
}) => {
  return <AlertStyled {...props} inline={inline} />;
};
